
import React from "react";
import { useNavigate } from "react-router-dom";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-28 px-4 max-w-4xl mx-auto pb-24">
      <div className="bg-white rounded-3xl shadow p-6 sm:p-8 space-y-6">

        <div className="flex justify-between items-center">
          <h1 className="text-2xl sm:text-3xl font-bold">
            Privacy Policy
          </h1>
          <button
            onClick={() => navigate(-1)}
            className="text-sm text-gray-500 hover:underline"
          >
            ← Back
          </button>
        </div>

        <p className="text-sm text-gray-600">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="space-y-4 text-sm text-gray-700">

          <p>
            This Privacy Policy explains how <strong>Expeditio</strong> collects,
            uses, and protects your data while providing AI-powered travel
            planning, trip management, and collaboration features.
          </p>

          {/* 1 */}
          <h2 className="font-semibold text-gray-900">
            1. Information We Collect
          </h2>
          <ul className="list-disc ml-5 space-y-1">
            <li>Name and email address</li>
            <li>Google profile information (if Google login is used)</li>
            <li>Travel itineraries, preferences, and saved trips</li>
            <li>Collaboration data (shared trips, edits, participants)</li>
            <li>Platform usage and activity logs</li>
          </ul>

          {/* 2 */}
          <h2 className="font-semibold text-gray-900">
            2. How We Use Your Information
          </h2>
          <ul className="list-disc ml-5 space-y-1">
            <li>Authentication and account management</li>
            <li>Generating AI-powered travel itineraries</li>
            <li>Enabling trip management and organization</li>
            <li>Supporting collaboration with friends and co-travelers</li>
            <li>Improving platform performance and user experience</li>
          </ul>

          {/* 3 */}
          <h2 className="font-semibold text-gray-900">
            3. Collaboration & Shared Trips
          </h2>
          <p>
            Expeditio allows users to collaborate on trips with friends or
            co-travelers. When you share a trip:
          </p>
          <ul className="list-disc ml-5 space-y-1">
            <li>Other participants can view and edit the itinerary</li>
            <li>Changes made by collaborators may be visible to all members</li>
            <li>You control who has access to your shared trips</li>
          </ul>

          {/* 4 */}
          <h2 className="font-semibold text-gray-900">
            4. Data Sharing
          </h2>
          <p>
            We do <strong>not</strong> sell or rent your personal data.
            Data is only shared with:
          </p>
          <ul className="list-disc ml-5 space-y-1">
            <li>Authentication providers (e.g., Google OAuth)</li>
            <li>Trusted infrastructure services required to run the platform</li>
          </ul>

          {/* 5 */}
          <h2 className="font-semibold text-gray-900">
            5. Cookies & Storage
          </h2>
          <p>
            We use browser storage (localStorage / sessionStorage) and secure
            cookies to manage login sessions, preferences, and seamless
            collaboration features.
          </p>

          {/* 6 */}
          <h2 className="font-semibold text-gray-900">
            6. Data Security
          </h2>
          <p>
            We use secure authentication (JWT), encrypted communication, and
            modern security practices to protect your data and shared trips.
          </p>

          {/* 7 */}
          <h2 className="font-semibold text-gray-900">
            7. User Rights
          </h2>
          <p>
            You may request account deletion, data export, or removal of shared
            trip data at any time by contacting us.
          </p>

          {/* 8 */}
          <h2 className="font-semibold text-gray-900">
            8. Changes to This Policy
          </h2>
          <p>
            This Privacy Policy may be updated to reflect new features such as
            collaboration tools, travel management improvements, or legal
            requirements.
          </p>

          {/* 9 */}
          <h2 className="font-semibold text-gray-900">
            9. Contact
          </h2>
          <p>
            If you have questions about this policy:
            <br />
            <strong>Email:</strong> expeditio.travel@gmail.com
          </p>

        </section>

      </div>
    </div>
  );
};

export default Privacy;
